<template>
    <div class="page-container">
        <div class="condition-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item>
                    <el-input v-model="queryParams.clientUsername" clearable placeholder="请输入设备编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryParams.orderNo" clearable placeholder="请输入订单编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="rangeTime" type="daterange" value-format="yyyy-MM-dd" align="right"
                        unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="$dateQuickPickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-container">
            <el-table v-loading="loading" :data="list" stripe border>
                <div slot="empty">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <el-table-column prop="imei" label="设备编号(SN)"></el-table-column>
                <el-table-column prop="orderNo" label="订单编号"></el-table-column>
                <el-table-column label="打印诉求" width="100">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.delay == 0">立即打印</el-tag>
                        <el-tag type="danger" v-else>延迟{{ scope.row.delay }}分钟打印</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="回调需求" width="80">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.needCallback == 1">需要</el-tag>
                        <el-tag type="danger" v-else>不需要</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="打印内容" width="80">
                    <template slot-scope="scope">
                        <div class="detail" @click="detail(scope.row)">点击查看</div>
                    </template>
                </el-table-column>
                <el-table-column label="任务状态" width="80">
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.status == 1">已取消</el-tag>
                        <el-tag type="info" v-else-if="!scope.row.printResult">待处理</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.printResult == 1">已下发</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.printResult == 2">已接收</el-tag>
                        <el-tag type="success" v-else-if="scope.row.printResult == 3">已完成</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.printResult == 4 || scope.row.printResult == 5">待重推
                        </el-tag>
                        <el-tag type="danger" v-else>其他</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="completeTime" label="完成时间" width="180"></el-table-column>
                <el-table-column prop="costTime" label="耗时(s)" width="70"></el-table-column>
                <el-table-column label="操作" width="148">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="reprint(scope.row.id)">重打
                        </el-button>
                        <el-button size="mini" type="danger"
                            :disabled="scope.row.status == 1 || scope.row.printResult == 3"
                            @click="setComplete(scope.row)">取消
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paging-container paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum" :page-sizes="$pageSizes" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 打印内容详情 -->
        <el-dialog title="打印内容" :visible.sync="detailVisible" :close-on-click-modal="false" width="640px">
            <div class="task-content">{{ taskContent }}</div>
            <div slot="footer" class="dialog-footer">
                <el-button id="copy" :data-clipboard-text="taskContent">复 制</el-button>
                <el-button type="primary" @click="detailVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
var moment = require('moment');
import Clipboard from 'clipboard';

export default {
    data() {
        return {
            clipboard: null,
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                clientUsername: null,
                orderNo: null,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: [],
            detailVisible: false,
            taskContent: ""
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        let loginInfo = JSON.parse(loginInfoStr);
        let developer = loginInfo.developer;
        let token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    mounted() {
        this.clipboard = new Clipboard("#copy");
        this.clipboard.on("success", () => {
            this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },
    destroyed() {
        this.clipboard.destroy();
    },
    methods: {
        handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query(pageNum) {
            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime && this.rangeTime.length == 2) {
                this.queryParams.beginTime = this.rangeTime[0];
                let endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listPrintTask", {
                params: this.queryParams,
                headers: this.headers
            }).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.total = res.data.total;
                    let result = res.data.rows;
                    for (let i = 0; i < result.length; i++) {
                        let item = result[i];
                        if (item.completeTime) {
                            let diff = moment(item.completeTime).diff(moment(item.createTime), 's');
                            item.costTime = diff;
                        }
                    }
                    this.list = res.data.rows;
                }
            });
        },
        detail(item) {
            this.taskContent = item.content;
            this.detailVisible = true;
        },
        reprint(developerPrintTaskId) {
            this.$confirm('亲，是否确认立即重打该任务？', '确认信息').then(() => {
                this.axios.post(this.$apiUrl + "/developbackend/reprint/" + developerPrintTaskId, {}, {
                    headers: this.headers
                }).then(res => {
                    if (res.data.code != 200) {
                        this.$showErrorMsg(res.data.msg);
                    } else {
                        this.$showSuccessMsg("亲，打印任务已重新下发啦~");
                        this.handleCurrentChange(1);
                    }
                });
            }).catch(() => { });
        },
        setComplete(developerPrintTask) {
            this.$confirm('亲，是否确认取消该打印任务？', '确认信息').then(() => {
                this.axios.put(this.$apiUrl + "/developbackend/deletePrintTask/" + developerPrintTask.id, {}, {
                    headers: this.headers
                }).then(res => {
                    if (res.data.code != 200) {
                        this.$showErrorMsg(res.data.msg);
                    } else {
                        developerPrintTask.status = 1;
                        this.$showSuccessMsg("亲，待打印任务已成功取消啦~");
                    }
                });
            }).catch(() => { });
        }
    }
}
</script>


<style scoped>
.page-container {
    height: 100%;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

.data-container {
    overflow-y: scroll;
}

.detail {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
}

.task-content {
    max-height: 420px;
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// printRecord.vue?a59cbde4